/**
 * Open a toast using Liferay.Util.openToast.
 *
 * @param {Object} [options]
 * @param {number | boolean} [options.autoClose=true] Auto-close setting (true=10000ms, false=disabled, number=ms). Default is 'true'
 * @param {HTMLElement} [options.container] Container element
 * @param {string} [options.containerId] Container element id
 * @param {'danger' | 'info' | 'success' | 'warning'} [options.displayType='info'] Toast type. Default is 'info'
 * @param {string | HTMLElement} options.message Message to display
 * @param {string} [options.title] Optional title
 * @returns {{close: function():void}} Handle with close() (no-op for Liferay)
 */
export function openToast({
    autoClose = true,
    container,
    containerId = '',
    displayType = 'info',
    message,
    title,
} = {}) {
    const autoCloseMs = autoClose === true ? 10000 : autoClose === false ? false : Number(autoClose);

    let targetContainer = container;
    if (!targetContainer && typeof containerId === 'string' && containerId.length > 0) {
        targetContainer = document.getElementById(containerId) || undefined;
    }

    try {
        if (window.Liferay && window.Liferay.Util && typeof window.Liferay.Util.openToast === 'function') {
            window.Liferay.Util.openToast({
                autoClose: autoCloseMs,
                container: targetContainer,
                containerId,
                message,
                title,
                type: displayType,
            });

            return { close: () => {} };
        }
    } catch (err) {
        console.warn('openToast call failed', err);
    }

    return { close: () => {} };
}
